<div class="user-details-container">
  <h1>User Details</h1>
  <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>
  <div *ngIf="user">
    <p><strong>ID:</strong> {{ user.id }}</p>
    <p><strong>Username:</strong> {{ user.username }}</p>
    <p><strong>Email:</strong> {{ user.email }}</p>
    <p><strong>Nacionalidad:</strong> {{ user?.nacionalidad }}</p>
    <p><strong>Facebook:</strong> {{ user?.facebook }}</p>
    <p><strong>Twitter:</strong> {{ user?.twitter }}</p>
    <p><strong>Instagram:</strong> {{ user?.instagram }}</p>
    <p><strong>Imagen Perfil:</strong> {{ user?.imgPerfil }}</p>
    <p><strong>Imagen Banner:</strong> {{ user?.imgBanner }}</p>
    <p><strong>Fecha de creacion:</strong> {{ user?.createdAt }}</p>
    <p><strong>Fecha de actualizacion:</strong> {{ user?.updatedAt }}</p>
    <p><strong>Cuenta no expirada:</strong> {{ user?.accountNonExpired }}</p>
    <p><strong>Cuenta no bloqueada:</strong> {{ user?.accountNonLocked }}</p>
    <p><strong>Credenciales no expirada:</strong> {{ user?.credentialsNonExpired }}</p>
    <p><strong>Cuenta habilitada:</strong> {{ user?.enabled }}</p>
    <p><strong>Role:</strong> {{ user?.role }}</p>
    <button (click)="enableEditing()">Edit</button>
  </div>

  <!-- Mensaje si no hay usuario -->
  <ng-template #noUser>
    <p>No se encontró información del usuario. Por favor, inicie sesión.</p>
  </ng-template>

  <!-- Edit mode -->
  <div *ngIf="isEditing && editableUser">
    <label>
      Username:
      <input [(ngModel)]="editableUser.username" name="username" />
    </label>
    <label>
      Email:
      <input [(ngModel)]="editableUser.email" name="email" />
    </label>
    <label>
      Role:
      <input [(ngModel)]="editableUser.role" name="role" />
    </label>
    <button (click)="saveChanges()">Save</button>
  </div>
</div>